import { TChecklistModelType } from '@teinor/erp/types/company/config/customerProject/tChecklist'
import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'
export interface TChecklistAction {
    type: 'CHANGE_T_CHECKLISTS'
    payload: TChecklistsPayload
}
export type TChecklistsPayload = TChecklistModelType[]
export type BuyTagJson = { [id: number]: TChecklistModelType } | null
export default function tChecklists(state: BuyTagJson = null, action: TChecklistAction): BuyTagJson {
    switch (action.type) {
        case 'CHANGE_T_CHECKLISTS':
            return state = dictionaryComplexFromJsonArr(action.payload)
        default:
            return state
    }
}